import { Component, ElementRef, ViewChild, OnInit, AfterViewInit, Renderer2, Inject, ViewChildren, QueryList } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ChatDataService } from '../../services/chat-data.service';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { ChatService } from '../../services/chat.service';
import { Subscription } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';
import * as Tablesort from 'tablesort';
import { GlobalService } from '../../services/global.service';
import { User } from '../../models/user';
import { MessageHandler } from 'src/app/shared/handlers/message-handler';
import * as XLSX from 'xlsx';
import { Scenario } from '../../models/scenario';
import { environment } from 'src/environments/environment';
import { AlertHandler } from '../../handlers/alert-handler';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit, AfterViewInit {
  @ViewChild('chatContainer') chatContainer: ElementRef;
  @ViewChild('msgInput') messageInput: ElementRef<HTMLTextAreaElement>;
  @ViewChildren('markdownContainer') markdownContainers: QueryList<ElementRef>;
  private subscriptions = new Subscription();
  private selectedScenario: Scenario;
  isLocalhost: boolean = false;
  isMinimized: boolean = false;
  showScrollToBottom: boolean = false;
  isTyping: boolean = false;
  welcomeScreen: boolean = true;
  userMessage: string = '';
  user: User;

  showCopyToClipboardMessage: boolean = false;
  copiedTextIndex;

  showTable: boolean = false;
  tableHeader: string = '';
  tableBody: string = '';
  tableFooter: string = '';
  chatHistory: any[] = [];

  freqMessages = [
    {
      id: 1,
      question: `What is the demand for manufacturing network 'Belvita Crunchy' in 2030?`,
      image: 'assets/images/chat_icons/freq-question2.svg',
      runTask: (question?: string) => {
        this.handleFaQ(question);
      },
    },
    {
      id: 2,
      question: 'What is the performance capex for 2029 for Belvita?',
      image: 'assets/images/chat_icons/freq-question3.svg',
      runTask: (question?: string) => {
        this.handleFaQ(question);
      },
    },
  ];

  socketWebUrl_uat_non_contextual = `${environment.socketConfig.url}/${environment.socketConfig.options.nonContextual}/`;
  socketWebUrl_uat_contextual = `${environment.socketConfig.url}/${environment.socketConfig.options.contextual}/`;

  socketWebUrl = this.socketWebUrl_uat_contextual;
  visibleFreqMessage = environment.showFrequentChatQuestion;

  constructor(
    private chatService: ChatService,
    private globalService: GlobalService,
    private chatDataService: ChatDataService,
    private mondelezDataService: MondelezDataService,
    public dialogRef: MatDialogRef<ChatComponent>,
    private renderer: Renderer2,
    public sanitizer: DomSanitizer,
    private clipboard: Clipboard,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (window.location.hostname === 'localhost') this.isLocalhost = true;
    else this.isLocalhost = false;
    this.selectedScenario = this.mondelezDataService.currentScenario;
  }

  ngOnInit(): void {
    this.user = this.globalService.user;
    this.isMinimized = this.data.isMinimized;
    this.toggleSize();
    this.welcomeScreen = true;
    this.showScrollToBottom = false;
    if (this.data.messages && this.data.messages?.length !== 0) {
      this.welcomeScreen = false;
      this.showScrollToBottom = true;
      this.chatDataService.chatStatus.subscribe((chatStatus) => {
        this.isTyping = chatStatus.isTyping;
      });
    }
    this.chatInitService();
    console.log('Web Socket: ', this.socketWebUrl);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  chatInitService() {
    if (this.isLocalhost) {
      this.chatService.initSocket(8007);
    } else {
      this.chatService.initServerSocket(this.socketWebUrl);
    }
    this.subscribeData();
  }

  ngAfterViewInit() {
    if (this.chatContainer) {
      this.renderer.listen(this.chatContainer.nativeElement, 'scroll', () => {
        this.onScroll();
      });
    }

    this.markdownContainers.changes.subscribe(() => {
      this.markdownContainers.forEach((container: ElementRef, index) => {
        this.onMarkdownReady(container, index);
      });
    });

    // Initialize First Load
    // this.markdownContainers.forEach((container: ElementRef) => {
    //   this.onMarkdownReady(container);
    // });
  }

  private subscribeData() {
    this.subscriptions.add(
      this.chatDataService.newChat.subscribe((data) => {
        if (data) {
          this.chatService.closeConnection();
          if (this.isLocalhost) {
            this.chatService.initSocket(8007);
          } else {
            this.chatService.initServerSocket(this.socketWebUrl);
          }
        }
      }),
    );
  }

  handleFaQ(question: string) {
    this.userMessage = question;
    this.sendMessage();
  }

  handleEnter(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default action (moving to a new line)
      this.sendMessage(); // Call your sendMessage method
    }
  }

  public showPreviousSession() {
    this.getChatHistory();
    this.welcomeScreen = false;
  }

  public async sendMessage() {
    if (!this.userMessage.trim()) return;

    //show chat window
    if (this.welcomeScreen) {
      this.data.messages = [];
      this.welcomeScreen = false;
    }

    const currentTime = new Date();
    this.data.messages.push({
      sender: 'you',
      text: this.userMessage,
      time: currentTime.toUTCString(),
      image: null,
    });

    this.chatDataService.setChatStatus({ messages: this.data.messages, isTyping: true });
    let userQueryObj = { message: this.userMessage, scenario: this.selectedScenario, createdTime: new Date(Date.now()) };

    this.isTyping = true;
    this.userMessage = '';
    this.scrollToBtm();
    this.resetTextareaHeight();

    this.chatService.sendMessage(userQueryObj);

    (await this.chatService.getMessage()).subscribe((res) => {
      if (res) {
        if (res.message !== undefined) {
          this.isTyping = false;
          this.scrollToBtm();
          let tableJson = res.table_json;
          if (res.table_json !== '') {
            tableJson = typeof res.table_json === 'string' ? JSON.parse(res.table_json) : res.table_json;
          }

          setTimeout(() => {
            this.focusOnInput();
            let [text, additionalInfo] = res.message?.split('\n\nAdditional Info:\n\n');
            if (additionalInfo) {
              additionalInfo = additionalInfo + '<br/>' + res?.optional_response;
            } else {
              additionalInfo = res?.optional_response;
            }

            this.data.messages.push({
              sender: 'other',
              id: res.id,
              text,
              additionalInfo,
              user_liked: null,
              time: currentTime.toUTCString(),
              tableData: tableJson,
              tableExpanded: false,
              additionalInfoExpanded: false,
              columns: [],
              sortColumn: null,
              sortDirection: 'asc',
            });
          }, 0);

          this.chatDataService.setChatStatus({ messages: [], isTyping: false });
        }
      }
    });
  }

  onClose(): void {
    this.chatDataService.setChatStatus({ messages: this.data.messages, isTyping: this.isTyping ? true : false });
    this.dialogRef.close(this.data);
  }

  toggleSize() {
    if (this.isMinimized) {
      // Minimizing: Set to smaller size and adjust position if necessary
      this.dialogRef.updateSize('18vw', '70vh');
      this.dialogRef.updatePosition({ right: '3rem', bottom: '5rem' });
    } else {
      // Maximizing: Center the dialog and set it to a larger size
      this.dialogRef.updateSize('68vw', '80vh');
      this.dialogRef.updatePosition({ top: '6rem', left: '20rem', bottom: '1rem' });
    }
    this.isMinimized = !this.isMinimized;
    this.scrollToBtm();
  }

  expandTable(i) {
    this.data.messages[i].tableExpanded = true;

    if (this.data.messages[i].tableData && this.data.messages[i].tableExpanded) {
      let jsonData = this.data.messages[i].tableData;
      this.data.messages[i].columns = this.extractColumns(jsonData);
    }

    this.isMinimized = true;
    this.dialogRef.updateSize('68vw', '80vh');
    this.dialogRef.updatePosition({ top: '6rem', left: '20rem', bottom: '1rem' });
  }

  extractColumns(data: any[]): string[] {
    if (!data || data.length === 0) {
      return [];
    }

    const firstRow = data[0];
    const keys = Object.keys(firstRow);

    // Ensure text-based columns appear before numeric columns
    const textKeys = keys.filter((key) => isNaN(Number(key))); // Strings first
    const numberKeys = keys.filter((key) => !isNaN(Number(key))); // Numeric keys next

    return [...textKeys, ...numberKeys];
  }

  getSortIcon(message: any, column: string): string {
    if (message.sortColumn === column) {
      return message.sortDirection === 'asc' ? '↑' : '↓';
    }
    return '⇅'; // Default sorting icon
  }

  sortData(tableIndex: number, column: string) {
    const table = this.data.messages[tableIndex];
    if (table.sortColumn === column) {
      table.sortDirection = table.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      table.sortColumn = column;
      table.sortDirection = 'asc';
    }

    table.tableData.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];

      if (!isNaN(Number(valueA)) && !isNaN(Number(valueB))) {
        return table.sortDirection === 'asc' ? valueA - valueB : valueB - valueA;
      } else {
        return table.sortDirection === 'asc' ? String(valueA).localeCompare(String(valueB)) : String(valueB).localeCompare(String(valueA));
      }
    });
  }

  onScroll() {
    const threshold = 100; // Distance from bottom to show the arrow
    const position = this.chatContainer.nativeElement.scrollTop + this.chatContainer.nativeElement.clientHeight;
    const height = this.chatContainer.nativeElement.scrollHeight;

    if (height - position > threshold) {
      this.showScrollToBottom = true;
    } else {
      this.showScrollToBottom = false;
    }
  }

  scrollToBtmSmooth() {
    setTimeout(() => {
      this.chatContainer.nativeElement.scrollTo({
        top: this.chatContainer.nativeElement.scrollHeight,
        behavior: 'smooth',
      });
    }, 100);
  }

  scrollToBtm() {
    setTimeout(() => {
      this.chatContainer.nativeElement.scrollTo({
        top: this.chatContainer.nativeElement.scrollHeight,
      });
    }, 10);
  }

  autoGrow(textarea: HTMLTextAreaElement) {
    // Reset height to auto to calculate scrollHeight properly
    textarea.style.height = 'auto';

    // Get the scrollHeight of the textarea
    const scrollHeight = textarea.scrollHeight;

    // Calculate the maximum height (10 lines)
    const maxHeight = parseFloat(getComputedStyle(textarea).lineHeight) * 10.75; //0.75 added to consider the padding

    // Set the height conditionally
    if (scrollHeight <= maxHeight) {
      textarea.style.height = scrollHeight + 'px';
      textarea.style.overflow = 'hidden';
    } else {
      textarea.style.height = maxHeight + 'px';
      textarea.style.overflowY = 'auto';
    }
  }

  resetTextareaHeight() {
    const textarea = this.messageInput.nativeElement as HTMLTextAreaElement;
    textarea.style.height = 'auto'; // Revert to original height
    textarea.rows = 1; // Set back to initial row count
  }

  openNewChat() {
    this.data.messages = [];
    this.welcomeScreen = true;
    this.showScrollToBottom = false;
    this.stopChat();
    this.focusOnInput();
    this.chatService.closeConnection();
    setTimeout(() => {
      if (this.isLocalhost) {
        this.chatService.initSocket(8007);
      } else {
        this.chatService.initServerSocket(this.socketWebUrl);
      }
    }, 1000);
  }

  getChatHistory() {
    this.chatHistory = [];
    this.isTyping = true;
    let payload = {
      username: this.user['username'],
    };
    this.chatService.getChatHistory(payload).subscribe({
      next: (result: any) => {
        if (result && result.response === 'SUCCESS') {
          let history_of_chat = result['chat_history'];

          if (history_of_chat && history_of_chat.length > 0) {
            history_of_chat.reverse().forEach((chat, index) => {
              let userMessage = {
                sender: 'you',
                text: chat.request_message,
              };
              this.chatHistory.push(userMessage);
              let table_json = [];
              if (chat.table_json) {
                table_json = typeof chat.table_json === 'string' ? JSON.parse(chat.table_json) : chat.table_json;
              }
              const [text, additionalInfo] = chat.response_message?.split('\n\nAdditional Info:\n\n');
              let chatResponse = {
                sender: 'other',
                id: chat.id,
                user_liked: chat.user_liked,
                // text: chat.response_message,
                text,
                additionalInfo,
                tableData: table_json,
                tableExpanded: false,
                additionalInfoExpanded: false,
                columns: [],
                sortColumn: null,
                sortDirection: 'asc',
              };
              this.chatHistory.push(chatResponse);
            });
          }
          this.data.messages = this.chatHistory;
          this.isTyping = false;
          this.scrollToBtm();
        } else {
          AlertHandler.ErrorAlert(MessageHandler.INTERNAL_ERROR);
          this.isTyping = false;
        }
      },
      error: (error) => {
        AlertHandler.ErrorAlert(MessageHandler.INTERNAL_ERROR);
        this.isTyping = false;
      },
    });
  }

  stopChat() {
    this.isTyping = false;
  }

  onEdit(msgText: any) {
    this.userMessage = msgText;

    setTimeout(() => {
      this.focusOnInput();
      const textarea = this.messageInput.nativeElement as HTMLTextAreaElement;
      this.autoGrow(textarea);
    }, 100);
  }

  focusOnInput() {
    this.messageInput.nativeElement.focus();
  }

  onMarkdownReady(container, markdownIndex) {
    if (!container) return;

    this.addTablesortParsers();
    const tables = container.querySelectorAll ? container.querySelectorAll('table') : [];
    tables.forEach((table: HTMLTableElement, tableIndex: number) => {
      table.id = `table-${markdownIndex}`;
      new Tablesort(table, { descending: true });

      // table.addEventListener('beforeSort', function () {
      //   alert('Table is about to be sorted!');
      // });

      // table.addEventListener('afterSort', function () {
      //   alert('Table sorted!');
      // });

      // After sorting, format the numbers in the table
      // const cells = table.querySelectorAll('td');
      // cells.forEach((cell) => {
      //   const value = parseFloat(cell.innerText.replace(/,/g, ''));
      //   if (!isNaN(value)) {
      //     cell.innerText = this.formatNumber(value);
      //   }
      // });

      const headers = table.querySelectorAll('th');
      headers.forEach((header, index) => {
        header.setAttribute('data-index', `${tableIndex}-${index}`);
        header.addEventListener('click', () => this.updateSortIcons(headers, header));
      });

      // Adding Export to Excel and Export to CSV Button
      // Container for the buttons
      // const buttonContainer = document.createElement('div');
      // buttonContainer.classList.add('export-button-container');

      // //  CSV button
      // const csvButton = document.createElement('button');
      // csvButton.classList.add('csv-export-button', 'export-btn');
      // csvButton.innerText = 'Export as CSV';
      // csvButton.addEventListener('click', () => this.exportTableData(table, 'csv'));

      // //  Excel button
      // const excelButton = document.createElement('button');
      // excelButton.classList.add('excel-export-button', 'export-btn');

      // excelButton.innerText = 'Export as Excel';
      // excelButton.addEventListener('click', () => this.exportTableData(table, 'excel'));

      // // Append buttons to the container
      // buttonContainer.appendChild(csvButton);
      // buttonContainer.appendChild(excelButton);

      // // Insert the container after the table
      // table.insertAdjacentElement('afterend', buttonContainer);
    });
  }

  exportTableData(table: HTMLTableElement, format: string) {
    if (!table) {
      AlertHandler.ErrorAlert('No table found!');
      return;
    }

    const data = [];
    table.querySelectorAll('tr').forEach((row) => {
      const rowData = Array.from(row.querySelectorAll('th, td')).map((cell) => cell.textContent);
      data.push(rowData);
    });

    if (format === 'csv') {
      this.exportAsCSV(data);
    } else if (format === 'excel') {
      this.exportAsExcel(data);
    }
  }

  exportAsCSV(data: string[][]) {
    const csvContent = data.map((row) => row.join(',')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'table_data.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  exportAsExcel(data: string[][]) {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'table_data.xlsx');
  }

  addTablesortParsers(): void {
    Tablesort.extend(
      'number',
      (item) => {
        // Remove commas and check if the remaining string is a valid number
        return item.replace(/,/g, '').match(/^[-+]?[0-9]*\.?[0-9]+$/);
      },
      (a, b) => {
        // Remove commas and convert the string to a float for comparison
        const numA = parseFloat(a.replace(/,/g, ''));
        const numB = parseFloat(b.replace(/,/g, ''));
        return numB - numA;
      },
    );

    // Extend Tablesort to handle string sorting with localeCompare
    Tablesort.extend(
      'string',
      (item) => {
        return item.toLowerCase();
      },
      (a, b) => {
        return b.localeCompare(a);
      },
    );
  }

  updateSortIcons(headers: NodeListOf<HTMLTableHeaderCellElement>, sortedHeader: HTMLTableHeaderCellElement): void {
    headers.forEach((header) => {
      // Remove existing sort icons
      header.classList.remove('sort-asc', 'sort-desc');
      const icon = header.querySelector('.fa');
      if (icon) {
        icon.remove();
      }
    });

    // Determine sort order and add corresponding icon
    let iconClass = '';
    if (sortedHeader.getAttribute('aria-sort') === 'ascending') {
      sortedHeader.classList.add('sort-asc');
      iconClass = 'fa-sort-amount-asc';
    } else if (sortedHeader.getAttribute('aria-sort') === 'descending') {
      sortedHeader.classList.add('sort-desc');
      iconClass = 'fa-sort-amount-desc';
    }

    // Create and append the icon
    if (iconClass) {
      const icon = document.createElement('i');
      icon.classList.add('fa', iconClass);
      sortedHeader.appendChild(icon);
    }
  }

  formatNumber(value: number): string {
    if (value >= 1000000000) {
      return (value / 1000000000).toFixed(3) + 'B';
    } else if (value >= 1000000) {
      return (value / 1000000).toFixed(3) + 'M';
    } else if (value >= 1000) {
      return (value / 1000).toFixed(3) + 'k';
    } else {
      return value.toString();
    }
  }

  onCopy(messageIndex, sender) {
    if (this.clipboard.copy(this.data.messages[messageIndex].text)) {
      this.copiedTextIndex = messageIndex;
      this.showCopyToClipboardMessage = true;
      setTimeout(() => {
        this.showCopyToClipboardMessage = false;
      }, 3000);
    } else {
      console.log('Failed to copy');
      this.showCopyToClipboardMessage = false;
      this.copiedTextIndex;
    }
  }

  async onLikeDislike(message, liked, messageIndex) {
    let like_status = liked; // true -> message liked || false -> message unliked
    if (this.data.messages[messageIndex].user_liked === liked) {
      like_status = null; // setting it null incase we want to deselect the like status for a message
    }

    let userQueryObj = {
      user_id: this.user['user_id'],
      username: this.user['username'],
      email: this.user['email'],
      id: message.id,
      user_liked: like_status,
      scenario: this.selectedScenario,
    };

    this.chatService.sendFeedback(userQueryObj);
    (await this.chatService.getMessage()).subscribe((res) => {
      if (res) {
        if (res['response'] === 'SUCCESS') {
          // update user_liked flag in messages array to update icon
          this.data.messages[messageIndex].user_liked = like_status;

          this.isTyping = false;
          setTimeout(() => {
            this.focusOnInput();
          }, 10);
        }
      }
    });
  }
}
